// Centrale tracking-helpers voor GA4 (gtag) en Meta Pixel.
// Events vuren alleen als de betreffende tag geladen is.
type Params = Record<string, unknown>;

export function gaEvent(name: string, params?: Params) {
  if (typeof window === 'undefined') return;
  const gtag = (window as any).gtag;
  if (typeof gtag === 'function') gtag('event', name, params ?? {});
}

export function fbqTrack(event: string, params?: Params) {
  if (typeof window === 'undefined') return;
  const fbq = (window as any).fbq;
  if (typeof fbq === 'function') fbq('track', event, params ?? {});
}
